import Vue from 'vue'
import { getYPP } from '@fe/global'

export const YPP = getYPP()

export const IS_SERVER = Vue.prototype.$isServer

